import { useMemo } from 'react';

import { useListOmniClustersQuery } from 'hooks/queries/omni';

import { EdgeLocationRegion } from '../types';
import { getEdgeLocationProvider } from '../utils';

export const useEdgeLocationRegionsPerCluster = () => {
  const {
    data: omniClusters,
    isLoading,
    error,
    refetch,
  } = useListOmniClustersQuery({ includeEdgeLocations: true });

  const edgeLocationRegionsPerCluster = useMemo(() => {
    if (!omniClusters) {
      return {};
    }

    return omniClusters.reduce((acc, cluster) => {
      if (!cluster.edgeLocations) {
        return acc;
      }

      acc[cluster.id!] = cluster.edgeLocations.map((edgeLocation) => ({
        region: edgeLocation.region,
        provider: getEdgeLocationProvider(edgeLocation),
      }));

      return acc;
    }, {} as Record<string, EdgeLocationRegion[]>);
  }, [omniClusters]);

  return {
    edgeLocationRegionsPerCluster,
    isLoading,
    error,
    refetch,
  };
};
